<!-- components/ConsentBanner.vue -->
<script setup lang="ts">
const {gtag, initialize} = useGtag();
const { isVisible, show, hide, getConsent, saveConsent } = useConsent();

onMounted(() => {
  // On regarde si l'utilisateur a déjà répondu
  const choice = getConsent();
  if (!choice) {
    show();
  } else if (choice === "granted") {
    // Choix déjà accepté lors d'une session précédente : on réinitialise
    grant();
  }
});

function grant() {
  initialize(); // charge le script gtag.js
  gtag("consent", "update", {
    ad_storage: "granted",
    ad_user_data: "granted",
    ad_personalization: "granted",
    analytics_storage: "granted",
  });
  saveConsent("granted");
  hide();
}

function deny() {
  saveConsent("denied");
  hide();
}
</script>

<template>
  <div v-if="isVisible" class="fixed bottom-0 left-0 right-0 z-[9999] bg-[#1a1a1a] text-white p-4 sm:px-6 flex items-center justify-between gap-4 flex-wrap">
    <p>
      Nous utilisons des cookies pour mesurer l'efficacité de nos campagnes publicitaires.
      Vous pouvez accepter ou refuser ce suivi.
    </p>
    <div class="flex gap-2">
      <UButton color="neutral" variant="outline" @click="deny">Refuser</UButton>
      <UButton color="neutral" variant="outline" @click="grant">Accepter</UButton>
    </div>
  </div>
</template>
